import * as React from "react";

import EditEscalatorRTD from "../../Editing/EditEscalatorRTD";
import Table from "../../../components/Table/Table";
import { editActions } from "../../../actions/editActions";
import { pdApiActions } from "../../../actions/pdApiActions";
import { setEscalatorRTDExtraProperties } from "../../../utils/pdApiUtils";
import { Dimmer } from "semantic-ui-react";
import { mainActions } from "../../../actions/mainActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
import _ from "lodash";

/**
 * All the following props are passed from parent component
 */
export type EscalatorRTDsTableProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  isLoadingEscalatorRTDs: boolean;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  editActions: typeof editActions;
  pdApiActions: typeof pdApiActions;
  mainActions: typeof mainActions;
  toggleModal: () => void;
  subMenuRoute: State.EscalatorSubmenu;
  columnFilters: Filter[];
  setColumnFilters: (subMenuRoute: State.EscalatorSubmenu, columnFilter: Filter[]) => void;
};

type EscalatorRTDsTableState = {
  isModalOpen: boolean;
};

export class EscalatorRTDsTable extends React.Component<
  EscalatorRTDsTableProps,
  EscalatorRTDsTableState
> {
  state = {
    isModalOpen: false
  };

  componentDidMount(): void {//onload
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };
  
  componentWillUnmount(): void {
    this.props.mainActions.setLastEditedObjectId(undefined);
  }
  render(): JSX.Element {
    const { columns, pdApi, mainState, isEditActive, toggleModal, isLoadingEscalatorRTDs } = this.props;
    const { escalatorRTDs } = pdApi;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;
    const escalatorRTDRows: Api.EscalatorRTD[] = escalatorRTDs.map(row =>
      setEscalatorRTDExtraProperties(row, pdApi)
    );
    let selectedColumns: State.Column[] = [];

    selectedColumns = columns["Escalator RTDs"];
    const startingPage = mainState.lastEditedObjectId
      ? (escalatorRTDRows.findIndex(escalatorRTD => escalatorRTD.id === mainState.lastEditedObjectId) / // tslint:disable-line: no-bitwise
          mainState.pageSize) >>
        0
      : 0;
    // Add submenu specific columns and rows
    return (
      <div className="flex-1">
        <div className="flex-1">
          <Table
            startingPage={startingPage}
            rows={escalatorRTDRows}
            loading={isLoadingEscalatorRTDs}
            loadingText="Fetching escalator RTDs..."
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={this.props.editActions.select}
            isRowSelected={this.isEscalatorRTDSelected}
            pageSize={pageSize}
            handleFilterChange={this.handleFilterChangeDebounced}
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div className="edit-view" style={{ flex: editSize , width : editSize == 0.3 ? "500px" : "1000px" }}>
              <EditEscalatorRTD toggleModal={toggleModal} columns={columns} />
            </div>
          </Dimmer>
        )}
      </div>
    );
  }

  private isEscalatorRTDSelected = (escalatorRTD: Api.EscalatorRTD): boolean => {
    const editedObjectId = this.props.editedObjectId ?? this.props.mainState.lastEditedObjectId;
    if (editedObjectId && escalatorRTD.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

export default EscalatorRTDsTable;
